import request from '../../axios';
import {IPostStoreOrderDetailsPayload} from './usePostStoreOrderDetails';

const patchStoreOrderDetails = async (
  payload: IPostStoreOrderDetailsPayload,
) => {
  const formData = new FormData();

  if (payload.order_guid) {
    formData.append('order_guid', payload.order_guid);
  }

  if (payload.shipping_method !== undefined) {
    formData.append('shipping_method', String(payload.shipping_method));
  }

  if (payload.shipment_number) {
    formData.append('shipment_number', payload.shipment_number);
  }

  if (payload.delivery_date) {
    formData.append('delivery_date', payload.delivery_date);
  }

  if (payload.shipping_receipt instanceof File) {
    formData.append('shipping_receipt', payload.shipping_receipt);
  }

  return request.patch('/api/v2/order/order-delivery-detail', formData);
};

export default patchStoreOrderDetails;
